'use client'

import Link from 'next/link'
import { Box, Container, Heading, Text, Button, VStack, useColorModeValue, Icon } from '@chakra-ui/react'
import { ChevronLeftIcon } from '@chakra-ui/icons'

export default function BlogNotFound() {
  const bgColor = useColorModeValue('gray.900', 'gray.900')
  const textColor = useColorModeValue('gray.100', 'gray.100')

  return (
    <Box bg={bgColor} color={textColor} minHeight="100vh" display="flex" alignItems="center">
      <Container maxW="4xl">
        <VStack spacing={8} align="center" textAlign="center">
          <Heading as="h1" size="4xl" color="blue.400">
            404
          </Heading>
          <Heading as="h2" size="2xl">
            Blog Post Not Found
          </Heading>
          <Text fontSize="xl">Oops! The blog post you're looking for doesn't exist or has been moved.</Text>
          <Link href="/blogs" passHref>
            <Button leftIcon={<Icon as={ChevronLeftIcon} />} colorScheme="blue" size="lg">
              Back to All Blogs
            </Button>
          </Link>
        </VStack>
      </Container>
    </Box>
  )
}
